export default ['UAB','STANFORD','LIFESPAN'];
